
import { Module } from 'wrapper6'
import ImgToSvg from '../utils/_img-to-svg'
import { gsap } from 'gsap'

const $ = jQuery

export default class Tabs extends Module {
  ready (app) {
    this.addTabs()
  }

  addTabs () {
    // Convert image tags to svg
    new ImgToSvg()

    this.wrappers = document.querySelectorAll('.mtt-tabs')

    if (this.wrappers.length) {
      for (let i = 0; i < this.wrappers.length; i++) {
        const wrapper = this.wrappers[i]

        new TabWidget(wrapper)
      }
    }
  }
}

class TabWidget {
  constructor (wrapper) {
    this.wrapper = wrapper

    this.clickOnTab()
  }

  clickOnTab () {
    this.tabs = this.wrapper.querySelectorAll('.mtt-value-label')

    for (let i = 0; i < this.tabs.length; i++) {
      const tab = this.tabs[i]

      tab.addEventListener('click', () => {
        this.dataID = tab.getAttribute('data-id')

        this.showCorrectContent()
        this.highlightCorrectTab(tab)
      })
    }
  }

  showCorrectContent () {
    const activeContent = this.wrapper.querySelector('.mtt-tabs__section.active')

    this.hide(activeContent)
    this.show(this.wrapper.querySelector('.mtt-tabs__section[data-id="' + this.dataID + '"]'))
    this.animateContent()
  }

  animateContent () {
    const text = this.wrapper.getElementsByClassName('mtt-tabs__text')
    const image = this.wrapper.getElementsByClassName('mtt-tabs__image')

    gsap.fromTo(text, { x: '-100%', ease: 'back.out(1)' }, { x: '0', ease: 'back.out(1)' })

    gsap.fromTo(image, { x: '100%', ease: 'back.out(1)' }, { x: '0', ease: 'back.out(1)' })
  }

  highlightCorrectTab (tab) {
    this.wrapper.querySelector('.mtt-value-label.active').classList.remove('active')
    tab.classList.add('active')
  }

  hide (el) {
    if (el) {
      el.classList.add('hide')
      el.classList.remove('active')
    }
  }

  show (el) {
    if (el) {
      el.classList.remove('hide')
      el.classList.add('active')
    }
  }
}
